import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { graphql, useStaticQuery } from "gatsby"


function Top10({ data }) {

  const {area_name} = data

  const images = useStaticQuery(graphql`
      query {
          cp200d: file(relativePath: {eq: "CP200d.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          sl300: file(relativePath: {eq: "SL300.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr3300e: file(relativePath: {eq: "XPR3300e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr3500e: file(relativePath: {eq: "XPR3500e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          sl3500e: file(relativePath: {eq: "SL3500e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr7350e: file(relativePath: {eq: "XPR7350e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr7550e: file(relativePath: {eq: "XPR7550e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          bpR40: file(relativePath: {eq: "BPR40.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          cp185: file(relativePath: {eq: "CP185.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          dtr700: file(relativePath: {eq: "DTR700.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          otherRadios: file(relativePath: {eq: "commusa-other-popular-mobile-two-way-radios.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          cm200d: file(relativePath: {eq: "CM200d.jpg"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          cm300d: file(relativePath: {eq: "CM300d.jpg"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr2500: file(relativePath: {eq: "XPR2500.jpg"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr5350e: file(relativePath: {eq: "XPR5350e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr5380e: file(relativePath: {eq: "XPR5380e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr5550e: file(relativePath: {eq: "XPR5550e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          xpr5580e: file(relativePath: {eq: "XPR5580e.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
          tlk150: file(relativePath: {eq: "TLK150.png"}){
              childImageSharp {
                  fixed {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
      }
  `)

  return (
    <div className="container py-3">
      <div className="row" id="top-10-portable">
        <div className="col-12 mt-3">
          <h4>Top 10 Portable Two-Way Radios</h4>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.cp200d.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola CP200d Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">1. CP200d</h6>
          <p>The CP200d portable two-way radio is part of Motorola’s highly-popular Commercial Series. More durable and
            user-friendly than its predecessor, the CP200, organizations on a budget will appreciate this model’s value
            and its MOTOTRBO digital and analog capabilities.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.sl300.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola SL300 Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">2. SL300</h6>
          <p>Compact size and heavy-duty design collide in the MOTOTRBO SL300 portable two-way radio. Despite its slim
            body, the SL300 offers robust features, including a shatterproof display, extended range, and both analog
            and digital operation.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.xpr3300e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR3300e Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">3. XPR3300e</h6>
          <p>The MOTOTRBO XPR line from Motorola is arguably the most popular portable two-way radio line
            in {area_name}. That’s because XPR two-way radios include up to 28.5 hours of extended battery life, up to
            8% better range, and updated design with improved waterproofing.</p>
          <p>The XPR3300e is no exception. Well-suited for organizations on a budget, manufacturers, schools, and hotels
            love the 3300e for its enhanced audio features that cancel out environmental noise.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.xpr3500e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR3500e Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">4. XPR3500e</h6>
          <p>Similar to the XPR3300e, the MOTOTRBO XPR3500e is perfect for noisy environments. The difference is in the
            XPR3500e’s added display screen and additional channel capacity featuring a keypad for quick access option
            buttons and audio-free communication.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.sl3500e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola SL3500e Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">5. SL3500e</h6>
          <p>With a similar form factor to the slim SL300 and the feature sets of the amazing XPR3500e, the Motorola
            SL3500e is the best of both worlds. Small and lightweight in form, but with the technical capability to
            operate on advanced Motorola Repeater Systems such as IP Site Connect, Capacity Plus and Multi-Site Capacity
            Plus. With the SL3500e you don’t sacrifice performance for a radio you can fit in your pocket.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.xpr7350e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR7350e Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">6. XPR7350e</h6>
          <p>Motorola’s XPR7350e is a simple to use, powerful and incredibly durable radio. Made for the most rugged
            environments, the XPR7350e passes the test. When you need to safeguard your employees with a tough, reliable
            radio with exceptional audio quality and advanced features, look no further than the Motorola XPR7350e.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.xpr7550e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR7550e Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">7. XPR7550e</h6>
          <p>The XPR7550e is the ultimate power solution for organizations that need their portable two-way radio to go
            above and beyond. Well-suited for industrial organizations, the XPR7550e’s advanced color screen allows for
            texting and work order ticketing capabilities, even in the noisiest conditions.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.bpR40.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola BPR40 Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">8. BPR40</h6>
          <p>The Motorola Mag One BPR40 is a great entry level radio at an affordable price. Its compact design still
            offers a full 4 watts of power in UHF and 5 watts in VHF to provide excellent range. The best thing about
            this radio is that even though it's light and small, it still packs a punch with its durability.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.cp185.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola CP185 Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">9. CP185</h6>
          <p>The Motorola CP185 is another great entry level radio, but with a few more bells and whistles. Like its
            alphanumeric display that allows you to see your battery status or label your channels by name. If you use
            many channels, remembering which one your teams are on can be difficult. With the affordable CP185 radio,
            you can easily name your channels by their description, such as HSKP, MAINT or SECURITY. Last but not least,
            the CP185 is tough with its IP54 rating, backed by a full 2-year Motorola factory warranty.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10" fixed={images.dtr700.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola DTR700 Portable Two-Way Radio"/>
          <h6 className="mb-1 strong">10. DTR700</h6>
          <p>Just like its predecessor, the DTR650, the Motorola DTR700 is completely license free. The DTR700 operates
            on special 900mhz frequencies, set aside by the FCC for business operation. No need for you to spend time
            and money on FCC frequency coordination and associated costs. This slim and lightweight radio has up to 50
            channels available so you can separate your talkgroups or departments with ease. The DTR700 is IP54 rated,
            has a full graphic color display and best of all, not only can you make group calls, you can do private
            one-to-one calling as well.</p>
        </div>
        <div className="col-12 col-lg-8 mt-3">
          <div className="d-flex flex-row"> </div>
          <Img className="product top-10" fixed={images.otherRadios.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Two-Way Radio Dealer"/>
          <h6 className="mb-1 strong">Other popular portable two-way radio models include:</h6>
          <p>VL50, VX-261, EVX-261, XPR7380e, XPR7580e, SL7550e, SL7580e, SL7590e, and SLN1000. We even offer the
            TLK100, which is a handheld radio that works on the Verizon network for Nationwide coverage.</p>
          <p>In addition to our top-selling portables, CommUSA carries a wide selection of mobile two-way radios and
            base stations.</p>
          <div className="btn-group" role="group">
            <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
              className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                        href="https://www.commusa.com/contact-us">Request
            Quote</a>
          </div>
        </div>
      </div>
      <div className="row" id="top-10-mobile">
        <div className="col-12 mt-4">
          <h4>Top 10 Mobile Two-Way Radios</h4>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product mobile top-10" fixed={images.cm200d.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola CM200d (Analog Version) MOTOTRBO Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">1.&nbsp;CM200d (Analog Version) MOTOTRBO</h6>
          <p>Motorola designed its MOTOTRBO CM200d mobile two-way radio for the everyday driver. Surprisingly as
            affordable as it is durable, the CM200d has two times the capacity, greater coverage, and superior audio to
            comparable mobile radios. The Analog version can be programmed to your current analog radio system, but if
            or when you ever convert to a digital radio system, it can be upgraded with a simple and inexpensive
            software license.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product mobile top-10" fixed={images.cm200d.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola CM200d (Analog/Digital Version) MOTOTRBO Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">2.&nbsp;CM200d (Analog/Digital Version) MOTOTRBO</h6>
          <p>Just like the CM200d analog version, Motorola designed its MOTOTRBO CM200d analog/digital version to
            provide excellent audio quality and superior range at an affordable price. The analog/digital version has
            the added advantage that it can be programmed with both analog and digital channels, making any transition
            to a digital system as seamless as possible. Digital channels provide the added benefits of increased range,
            better audio quality and increased privacy.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10 mobile" fixed={images.cm300d.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola CM300d (Analog Version) MOTOTRBO Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">3.&nbsp;CM300d(Analog Version) MOTOTRBO</h6>
          <p>Similar to the CM200d, the CM300d offers an added digital display screen for enhanced capabilities,
            including caller ID.</p>
          <p>The CM200d and the CM300d are rated IP54. That means these models are splash- and dust-proof, perfect for
            the harshest of conditions.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10 mobile" fixed={images.cm300d.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola CM300d (Analog/Digital Version) MOTOTRBO Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">4.&nbsp;CM300d (Analog/Digital Version)</h6>
          <p>Just like the CM300d Analog version, the Digital version has an alphanumeric display and comes in either a
            1-25 Watt or 25-40 Watt version. The low power version is typically used for base station mode, while the
            high power version is used when you need to cover a larger area for both base station and mobile
            operation.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10 mobile" fixed={images.xpr2500.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR2500 Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">5.&nbsp;XPR2500</h6>
          <p>The XPR2500 is the budget-friendly communication solution your drivers need. Compact and hardy, this
            classic mobile radio features digital and analog capabilities plus twice the calling capacity and clearer
            audio than comparable mobile two-way radio base stations in {area_name}.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10 mobile" fixed={images.xpr5350e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR5350e Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">6.&nbsp;XPR5350e</h6>
          <p>Not meant for the occasional mobile radio user, the XPR5350e is a high-end yet compact mobile designed for
            ultimate connectivity. The 5350e has all the features you can expect from a Motorola XPR mobile radio,
            including integrated WiFi for remote software updates and free advanced software such as Capacity Plus and
            IP Site Connect capabilities.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10 mobile" fixed={images.xpr5380e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR5380e Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">7.&nbsp;XPR5380e</h6>
          <p>The XPR5380e is identical in features and capabilities to the XPR5350e, but operates in the 800/900 mhz
            frequency range. Like the XPR5350e, it has Bluetooth-enabled voice and data capabilities. Use WiFi to update
            software remotely and get trunking support to ensure your XPR5380e will grow as your organization does.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10 mobile" fixed={images.xpr5550e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR5550e Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">8.&nbsp;XPR5550e</h6>
          <p>Rugged and powerful, the XPR5550e offers a color digital screen with text messaging and work order
            ticketing capabilities in addition to the regular features that come with a Motorola XPR mobile radio. The
            XPR5550e has an added audio amplifier and is desktop microphone-compatible, making it ideal for dispatch
            systems.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10 mobile" fixed={images.xpr5580e.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola XPR5580e Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">9.&nbsp;XPR5580e</h6>
          <p>Motorola’s XPR5580e is for organizations operating on exclusive 800/900 mhz frequencies that need the best
            on-the-go mobile radio around. That’s why the XPR5580e features a quick access button for emergency alerts,
            hands-free accessories, text-to-speech functions, a color digital screen, and so much more.</p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3">
          <Img className="product top-10 mobile" fixed={images.tlk150.childImageSharp.fixed} objectFit={`contain`}
               alt="CommUSA Motorola TLK150 Mobile Two-Way Radio"/>
          <h6 className="mb-1 strong">10.&nbsp;TLK150</h6>
          <p>The Motorola TLK150 was designed just like it’s sister product, the TLK100, to provide simple Push-to-talk
            communication on Verizon’s Nationwide Cellular network, but in the formfactor of a vehicular mounted mobile
            radio. The TLK150 mobile radio is a great option for trucking, taxi cabs, school transportation, buses,
            fleet vehicles, distributors, or anyone else needed radio coverage over a large area like a City or State.
            Being on the Verizon networks means you can talk to your employees at the push of a button, whether they are
            across town or across the country.</p>
        </div>
        <div className="col-12 col-lg-8 mt-3 mobile-radios-last-col">
          <h6 className="mb-1 strong">Most of our Two-Way Radio Models can be programmed to be Compatible with these
            brands:</h6>
          <ul>
            <li>Vertex (aka Vertex Standard)</li>
            <li>Kenwood</li>
            <li>Icom</li>
            <li>Hytera (aka HYT)</li>
            <li>Ritron</li>
            <li>Maxon</li>
            <li>RCA</li>
            <li>Sonim</li>
            <li>Bearcom-branded radios</li>
          </ul>
          <div className="btn-group" role="group">
            <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
              className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                        href="https://www.commusa.com/contact-us">Request
            Quote</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Top10

